import React, { PropsWithChildren } from 'react';
import { Box } from '@landr/maestro';

const Actions: React.FC<PropsWithChildren<{ centeredActions?: boolean }>> = ({
    children,
    centeredActions = false,
}) => (
    <Box
        position="absolute"
        bottom="0"
        left="0"
        right="0"
        padding={centeredActions ? 'none' : 'sm'}
        height={centeredActions ? '100%' : 'auto'}
    >
        {children}
    </Box>
);

Actions.displayName = 'Card.Actions';

export default Actions;
